import { Package, Lock } from "lucide-react"

import { FeatureCard } from "./feature-card"
import { Badge } from "@/components/ui/badge"
import { MockCardOverlay } from "./mock-data-wrapper"

interface LanguagePacksCardProps {
  animationDelay?: number
}

const PACKS = [
  { name: "Top 100 Words", level: "L0", count: 100 },
  { name: "Top 500 Words", level: "L1", count: 500 },
  { name: "Top 1000 Words", level: "L2", count: 1000 },
  { name: "Essential Phrases", level: "L0", count: 50 },
]

export function LanguagePacksCard({
  animationDelay = 0,
}: LanguagePacksCardProps) {
  return (
    <FeatureCard
      title="Language Packs"
      icon={Package}
      iconColor="text-amber-600 dark:text-amber-400"
      iconBgColor="bg-amber-100 dark:bg-amber-900/30"
      animationDelay={animationDelay}
    >
      <MockCardOverlay message="Coming soon">
        <div className="space-y-3">
          {PACKS.map((pack) => (
            <div
              key={pack.name}
              className="bg-muted/30 flex items-center justify-between rounded-lg px-3 py-2"
            >
              <div className="flex items-center gap-2">
                <Lock className="text-muted-foreground size-3.5" />
                <span className="text-foreground text-sm">{pack.name}</span>
              </div>
              <Badge variant="secondary" className="text-xs">
                {pack.level}
              </Badge>
            </div>
          ))}
        </div>
      </MockCardOverlay>
    </FeatureCard>
  )
}
